<template>
  <Modal v-model="unableToStockUpModal" :title="$t('key1006829')" class-name="commonModalStyles"
    width="700" :transfer="false" :mask-closable="false">
    <h2 class="mb12 font-size-14 color-333 font-weight-bold">
      {{ $t('key1006830') }}
      <span class="themeColor">{{ details.name }}</span>
      {{ $t('key1006831') }}
      <span class="themeColor">{{ countryCodeList?.join('、') }}</span>
      {{ $t('key1006832') }} “
      <span class="themeColor">{{ $t('key1006833') }}</span>
      {{ $t('key1006834') }}
    </h2>
    <Table
      highlight-row
      border
      max-height="500"
      :columns="tableColumns"
      :data="tableData">
    </Table>
    <template #footer>
      <Button @click="unableToStockUpModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="unableToStockUpBtn">{{ $t('key1006835') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getAllCountrysData} from "@/utils/common";

export default {
  name: 'unableToStockUpModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      unableToStockUpModal: false,
      tableColumns: [
        {
          type: 'index',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'),
          width: 70,
          align: 'center'
        },
        {
          title: 'SKU',
          key: 'ymsSku',
          align: 'center',
          minWidth: 160
        },
      ],
      tableData: [],
      countryCodeList: [],
      details: {}
    }
  },
  methods: {
    // 初始化数据
    async initUnableToStockUpData(obj, data) {
      this.tableData = [];
      this.details = {};
      this.countryCodeList = [];
      let countryData = await getAllCountrysData();
      let list = [...new Set((obj.ymsWarehouseAddress || [])
        .filter(addr => addr.addressType === 'sender')
        .map(addr => addr.countryCode)
        .filter(Boolean)
      )];
      countryData.forEach(country => {
        if (list.includes(country.twoCode)) {
          this.countryCodeList.push(country.name);
        }
      });
      this.details = obj;
      data.forEach((val) => {
        this.tableData.push({
          ymsSku: val
        });
      });
      this.unableToStockUpModal = true;
    },
    // 去维护
    unableToStockUpBtn() {
      const skuList = [...new Set(this.tableData.map(item => item.ymsSku).filter(Boolean))];
      localStorage.setItem('unableToStockUpSkus', skuList.join('\n'));
      const {href} = this.$router.resolve({
        path: '/productCenter/productGoods'
      });
      window.open(href, '_blank');
      this.unableToStockUpModal = false;
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="less">

</style>
